/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbSharedRefineMenuTypeahead_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbSharedRefineMenuTypeaheadContainer_viewer$ref: FragmentReference;
export type SbSharedRefineMenuTypeaheadContainer_viewer = {|
  +isSearchWithinFilterEnabled: ?boolean,
  +$fragmentRefs: SbSharedRefineMenuTypeahead_viewer$ref,
  +$refType: SbSharedRefineMenuTypeaheadContainer_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuTypeaheadContainer_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuTypeahead_viewer",
      "args": null
    },
    {
      "kind": "ScalarField",
      "alias": "isSearchWithinFilterEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "REFINE_MENU_SEARCH",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"REFINE_MENU_SEARCH\")"
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'cdc32f46cd0d50c9dfad531b76e5bd14';
module.exports = node;
